import { render, staticRenderFns } from "./CorrectHistoryIcon.vue?vue&type=template&id=e58a82fa&scoped=true&"
import script from "./CorrectHistoryIcon.vue?vue&type=script&lang=js&"
export * from "./CorrectHistoryIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e58a82fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
